module.exports = __webpack_public_path__ + "img/problems-4.b086e967.png";